export default __webpack_public_path__ + "navigation-examples-route-alerts-thumbnail-960-b5ac76101fe70ac10fccda2d3f216ba3.png";